var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconOpenBook = function SvgIconOpenBook(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21.836,
    height: 16.682,
    viewBox: "0 0 21.836 16.682",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -35.048)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 35.048)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.612,35.049h0a.77.77,0,0,0-.547.227.778.778,0,0,0-.23.555V47.547a.784.784,0,0,0,.782.781,9.666,9.666,0,0,1,6.968,2.583V38.65a.749.749,0,0,0-.107-.4C40.751,35.475,37.435,35.053,35.612,35.049Z",
    transform: "translate(-32.272 -35.049)",
    fill: "#f6c866"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.5,47.546V35.829a.778.778,0,0,0-.23-.555.77.77,0,0,0-.547-.227h0c-1.823,0-5.138.426-6.864,3.2a.749.749,0,0,0-.107.4V50.91a9.666,9.666,0,0,1,6.968-2.583A.784.784,0,0,0,164.5,47.546Z",
    transform: "translate(-145.227 -35.048)",
    fill: "#f6c866"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.929,71.8h-.567v9.8a2,2,0,0,1-1.992,1.994,8.667,8.667,0,0,0-5.888,2.01,18.81,18.81,0,0,1,8.272.16A.781.781,0,0,0,180.71,85V72.582A.782.782,0,0,0,179.929,71.8Z",
    transform: "translate(-158.875 -69.099)",
    fill: "#f6c866"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.348,81.6V71.8H.781A.782.782,0,0,0,0,72.582V85a.781.781,0,0,0,.956.761,18.809,18.809,0,0,1,8.272-.16,8.666,8.666,0,0,0-5.888-2.01A2,2,0,0,1,1.348,81.6Z",
    transform: "translate(0 -69.099)",
    fill: "#f6c866"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconOpenBook, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-open-book.c8bc687b.svg";
export { ForwardRef as ReactComponent };